export default "__VITE_ASSET__B2fsOYnb__"